module.exports = __webpack_public_path__ + "45be067d4fd9f387cf11a92c37eb4164.pdf";